import { isAfter, isMatch, isValid, parse } from "date-fns";
import { dateMatchModifiers, dateLib } from "react-day-picker";
import { RANGE_SEPARATOR } from "./constants.js";
function isTextValid({
  text,
  date,
  dateFormat,
  locale,
  disabledDays
}) {
  if (!isMatch(text, dateFormat, {
    locale
  })) {
    return false;
  }
  if (!isValid(date)) {
    return false;
  }
  if (disabledDays && disabledDays.length) {
    const inputInvalid = dateMatchModifiers(date, disabledDays, dateLib);
    if (inputInvalid) {
      return false;
    }
  }
  return true;
}
function checkAndConvertDateString({
  text,
  dateFormat,
  locale,
  disabledDays,
  isRange
}) {
  function getDate(dateText) {
    return parse(dateText, dateFormat, /* @__PURE__ */ new Date(), {
      locale
    });
  }
  if (!isRange) {
    const date3 = getDate(text);
    if (!isTextValid({
      text,
      date: date3,
      dateFormat,
      locale,
      disabledDays
    })) {
      return {
        isTextValid: false
      };
    }
    return {
      isTextValid: true,
      date: date3
    };
  }
  const [text1, text2] = text.split(RANGE_SEPARATOR.trim()).map((str) => str.trim());
  const [date1, date2] = [getDate(text1), getDate(text2)];
  const firstTextValid = isTextValid({
    text: text1,
    date: date1,
    dateFormat,
    locale,
    disabledDays
  });
  const secondTextValid = isTextValid({
    text: text2,
    date: date2,
    dateFormat,
    locale,
    disabledDays
  });
  if (!firstTextValid || !secondTextValid) {
    return {
      isTextValid: false
    };
  }
  const date = isAfter(date1, date2) ? {
    from: date2,
    to: date1
  } : {
    from: date1,
    to: date2
  };
  return {
    isTextValid: true,
    date
  };
}
export {
  checkAndConvertDateString
};
//# sourceMappingURL=checkAndConvertDateString.js.map
